const Breakpoint = {
    LAPTOP_XS: '1540px',
    TABLET_L: '1250px',
    TABLET_XS: '750px',
    PHONE: '500px',
}

export default Breakpoint
